module.exports = __webpack_public_path__ + "videojs-record.fd6be9bcafbd78352527.eot";


//////////////////
// WEBPACK FOOTER
// /builds/applied-technologies/apt-lab/digitalbank-frontend-projects/digitalbank-web/node_modules/videojs-record/dist/css/font/videojs-record.eot
// module id = ../../../../videojs-record/dist/css/font/videojs-record.eot
// module chunks = styles